import React from "react";
import { Image, Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import "./FavoriteGamesDefinitionDrawer.scss";
import BottomDrawer from "../../BottomDrawer/BottomDrawer";
import { GenericModalProps } from "../../../utils/constants/generic-types";
import PrimaryActionButton from "../../Buttons/PrimaryActionButton/PrimaryActionButton";
import ImageFavoriteGameScreenshot from "../../../images/favorite-game-screenshot.png";

export default function FavoriteGamesDefinitionDrawer({
  isOpen,
  onClose,
}: GenericModalProps) {
  const { t } = useTranslation("games");
  return (
    <BottomDrawer
      isOpen={isOpen}
      onClose={onClose}
      showCloseBtn={false}
      containerClass="FavoriteGamesDefinitionDrawer"
    >
      <Stack gap={4}>
        <Stack className="TextContent">
          <span className="LoveEmoji">❤️</span>
          <h2 className="text-capitalize Title">{t("favorite_games")}</h2>
          <p className="Description">
            {t("these_are_games_you_have_added_to_your_favorite_list")}
          </p>
        </Stack>
        <Image
          src={ImageFavoriteGameScreenshot}
          alt="Favorite game screenshot"
          width={328}
          height={315}
        />
        <PrimaryActionButton text={t("common:got_it")} onClick={onClose} />
      </Stack>
    </BottomDrawer>
  );
}
